module.exports = __webpack_public_path__ + "static/media/Produtos4.fc8a9b30.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadProdutos/Produtos4.png
// module id = 2003
// module chunks = 0